import { MinimalScheduleType } from '@/enums/minimalScheduleType.enum';
import scheduleContainer from './scheduleContainer.schema';

export default {
  title: 'Harmonogram minimalny',
  type: 'object',
  properties: {
    minimalScheduleType: {
      title: 'schema.minimalSchedule.type',
      type: 'string',
      fieldRequired: true
    },
    price: {
      title: 'schema.fee.price',
      type: 'number',
      fieldRequired: `this.minimalScheduleType === '${MinimalScheduleType.FEE}'`
    },
    scheduleContainer: {
      title: 'Harmonogram',
      type: 'object',
      properties: {
        ...scheduleContainer.properties,
        entityId: {
          type: 'string',
          fieldRequired: false
        },
        entityType: {
          type: 'string',
          fieldRequired: false
        }
      }
    }
  }
};
